export default __webpack_public_path__ + "static/media/img1111.40923cfc.png";